import {EnvironmentProvider} from 'providers/EnvironmentProvider'
import {OrderDetailsProvider} from 'providers/OrderDetailsProvider'
import {OrderProvider} from 'providers/OrderProvider'
import {Queries} from 'providers/Queries'
import {Theme} from 'providers/Theme'
import {TimeoutProvider} from 'providers/TimeoutProvider'
import {Toaster} from 'providers/Toaster'
import {Basic} from 'types'
import {View} from './View'

export const CartItemBuilder = (input: Basic.Input) => {
  return (
    <Toaster>
      <EnvironmentProvider {...input}>
        <Theme>
          <OrderDetailsProvider>
            <Queries>
              <OrderProvider>
                <TimeoutProvider showTimeoutScreen={false}>
                  <View />
                </TimeoutProvider>
              </OrderProvider>
            </Queries>
          </OrderDetailsProvider>
        </Theme>
      </EnvironmentProvider>
    </Toaster>
  )
}
